(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lito-recipes"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lito-recipes')) {
  customElements.define('lito-recipes', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const filters = this.querySelector('.lr-filters');
      const buttons = Array.from(this.querySelectorAll('[data-lr-filter]'));
      const cards = Array.from(this.querySelectorAll('[data-lr-category]'));
      const count = this.querySelector('.lr-count');
      if (!filters || !count) return;
      filters.hidden = false;
      buttons.forEach(button => button.addEventListener('click', () => {
        const category = button.dataset.lrFilter;
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        let visible = 0;
        cards.forEach(card => {
          card.hidden = category !== 'all' && card.dataset.lrCategory !== category;
          if (!card.hidden) visible += 1;
        });
        count.textContent = visible + ' ' + (visible === 1 ? this.dataset.countSingular : this.dataset.countLabel);
      }));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
